import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statItemCodeLocaleModule: LocaleModule = {
  name: "statItemCode",
  messages: { en: en, it: it },
};
